import React from 'react'
import { getTextShort, formatDate } from '@helpers/helper.novelty'
import { Novelty, RealEstateDataPageComponentData, TagMediacore } from 'types'
import { Link } from 'gatsby'

type Props = {
  hidenTags: boolean
  skeleton: boolean
  hidenAuthor: boolean
  isHome: boolean
  novelty: Novelty
  tags: TagMediacore[]
  dispatch: any
  isSummaryCard: boolean
  placeholder?: string
  upperCaseLink?: boolean
  dateFormat?: 'long' | 'short'
  keyIndex?: number
}

const NoveltyCard_1 = (props: Props & RealEstateDataPageComponentData) => {
  const key = props?.keyIndex
  const hidenTags = props?.hidenTags
  const hidenAuthor = props?.hidenAuthor
  const isHome = props?.isHome
  const dateFormat = props?.global_data.content.cardsNovelties.data.dateFormat
  const upperCaseLink = props?.upperCaseLink
  const placeholder =
    props.global_data.content.cardsNovelties.data.placeholder ||
    props?.placeholder ||
    'Leer novedad completa'
  const {
    novelty,
    tags,
    skeleton,
    isSummaryCard,
    global_data: {
      divisionPath,
      content: {
        cardsNovelties: {
          data: { paragraphColor, paragraphHexa },
        },
      },
    },
  } = props

  const noveltyPath = novelty?.id
    ? `${divisionPath ?? ''}/novedad/${novelty.id}/${novelty.slug}`
    : '/'

  return (
    <Link
      to={noveltyPath}
      {...{ key }}
      className="mb-lg-4"
    >
      <div
        className={
          'novelty-card a cursor-pointer  ' +
          (isSummaryCard ? ' summary-card ' : '') +
          (isHome ? 'home' : '') +
          (skeleton ? ' skeleton ' : '')
        }
      >
        <img
          src={novelty?.image}
          alt=""
        />
        <div className="div-content d-flex flex-column p-5 text-start">
          <div className="div_texto">
            <span
              style={{ color: paragraphHexa }}
              className={'date ' + paragraphColor}
            >
              {formatDate(novelty?.date_published, dateFormat ? dateFormat : '')}
            </span>
            <h2 className="title mt-5">{getTextShort(novelty?.title, isHome ? 40 : 40)}</h2>
            <p className="description mt-3">
              {getTextShort(novelty?.headline, isHome ? 180 : 180)}
            </p>
          </div>
          <div
            className={
              'div_button col-12 text-center mt-auto d-lg-flex ' +
              (!hidenTags ? 'justify-content-between' : 'justify-content-center')
            }
          >
            <div className={'div_etiquetas flex-wrap ' + (hidenTags && 'd-none')}>
              {tags
                ? novelty?.tags.map(
                    (tag, index) =>
                      index < 2 && (
                        <span
                          key={index}
                          className="pill btn btn-primary me-2 mt-1 mt-lg-0"
                        >
                          {' '}
                          {tag?.name}{' '}
                        </span>
                      ),
                  )
                : ''}
            </div>
            <div
              className={'btn btn-primary mt-3 mt-lg-0' + (upperCaseLink ? ' text-uppercase' : '')}
            >
              {placeholder ? placeholder : 'Leer novedad completa'}
            </div>
          </div>
          {!hidenAuthor && novelty?.author !== '' && (
            <span className={'by-name' + (hidenAuthor ? ' d-none' : '')}>
              por {novelty?.author}
            </span>
          )}
        </div>
      </div>
    </Link>
  )
}

export default NoveltyCard_1
